import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(3),
  },
  mainInfo: {
    color: theme.palette.neutral.main,
    marginBottom: theme.spacing(3),
  },
  buttonsWrapper: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },

  textWrapper: {
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },

  rememberText: {
    gap: theme.spacing(2),
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },

  checkboxRow: {
    display:'flex',
    alignContent:'start', 
    alignItems:'center',
    marginBottom: theme.spacing(1),
  },

  email: {
    paddingInline:theme.spacing(5),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(3),
  },

  emailInput: {
    paddingInline:theme.spacing(5),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },

  checkbox: {
    margin:0,
  },
}))

export default useStyles
